import { render, staticRenderFns } from "./HrStatsTable.vue?vue&type=template&id=85288ad2&scoped=true&"
import script from "./HrStatsTable.vue?vue&type=script&lang=js&"
export * from "./HrStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./HrStatsTable.vue?vue&type=style&index=0&id=85288ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85288ad2",
  null
  
)

export default component.exports